import { render, staticRenderFns } from "./weightLoss.vue?vue&type=template&id=49966d9c&"
import script from "./weightLoss.vue?vue&type=script&lang=js&"
export * from "./weightLoss.vue?vue&type=script&lang=js&"
import style0 from "./weightLoss.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports